import { useEffect, useState } from "react";
import {
  ensureAssignedUnreadSocketListeners,
  getAssignedUnreadTotal,
  refreshAssignedUnreadTotal,
  subscribeAssignedUnread,
} from "../utils/assignedChatUnreadStore";

/**
 * Live sidebar total unread for assigned CSR or Sales customer chats.
 * @param {'csr'|'sales'} channel
 * @param {boolean} enabled
 */
export default function useAssignedChatUnreadCount(channel, enabled = true) {
  const [count, setCount] = useState(() =>
    enabled ? getAssignedUnreadTotal(channel) : 0
  );

  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return undefined;
    }
    ensureAssignedUnreadSocketListeners();
    refreshAssignedUnreadTotal(channel);
    return subscribeAssignedUnread((snap) => {
      const key = channel === "sales" ? "sales" : "csr";
      setCount(Number(snap?.[key]?.total) || 0);
    });
  }, [channel, enabled]);

  return count;
}
